import styled from "styled-components";
import {ReactNode} from "react";


export default function SchemaEditContainer({children}: { children: ReactNode }) {

    return <Container>
        {children}
    </Container>
}

const Container = styled.div`
  //height: 100%;
  max-height: calc(98vh - var(--header-height));
  background-color: var(--table-row-odd-bg-color);
  padding: .5rem;
  border-radius: .5rem;
  max-width: 90vw;
  min-width: 300px;
  overflow-y: auto;
  display: flex;
  flex-flow: column;
  gap: .5rem;

  .controls {
    display: flex;
    justify-content: end;
    gap: .5rem;

    .delete {
        margin-right: auto;
    }

    .save {
      background-color: green;
      color: white;
    }
  }

  .join-deps {
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;

    .dep {
      padding: .2rem;
      border-radius: .2rem;
      background-color: var(--table-row-even-bg-color);
      border: 2px solid var(--table-border-color);
    }
  }

  .delete-join {
    display: flex;
    gap: .5rem;
    flex-wrap: wrap;
    align-items: center;
  }

  .new-text-area {

    & textarea {
      width: 100%;
    }
  }

  .edit-field-joins {

  }
`
